import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const GetEventTypeList = async () => {
  const EventList = await AxiosGetMethod("org/event-type-list");
  if (EventList.status === 200) {
    return EventList.data.data;
  } else {
    if (EventList?.status === 401) HandleLogout();
    ErrorToast("Error on fetch event List");
  }
};

export default GetEventTypeList;
